import React from 'react';
import styled from "styled-components";
const Container = styled.ul`
  list-style-type: none;
  margin: 0;
  display: none;
  @media (min-width: 826px){
    display: initial;
  }
  
`
const Item = styled.li`
  opacity: .9;
  display: inline-block;
  margin-left: 14px;
  margin-right: 14px;
  margin-top: 0;
  margin-bottom: 0;
  cursor: pointer;
  &:hover {
    background-color: transparent;
  }
  
  a {
    border: 1px solid var(--cPrimaryDark);
    border-radius: 50%;
    width: 34px;
    height: 34px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    i {
    line-height: 0;
    color: var(--cPrimaryDark);
  }
    &:hover{
    background-color: var(--cPrimaryLight);
    border-color: var(--cPrimaryLight);
    i{
      color: #FFF;
    }
  }
  }
 
  
  
  
  
`
const Social = () => (
  <Container>
    <Item><a target="__blank" href="https://www.youtube.com/user/sistematagplus/"><i className="fab fa-youtube"/></a></Item>
    <Item><a target="__blank" href="https://twitter.com/TagPlusOficial"><i className="fab fa-twitter"/></a></Item>
    <Item><a target="__blank" href="https://www.facebook.com/tagplusonline/"><i className="fab fa-facebook-f"/></a></Item>
    <Item><a target="__blank" href="https://www.linkedin.com/company/tagplus/"><i className="fab fa-linkedin-in"/></a></Item>
    <Item><a target="__blank" href="https://www.instagram.com/tagplus.oficial/"><i className="fab fa-instagram"/></a></Item>
  </Container>
)


export default Social